import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { push } from 'react-router-redux';
import { buildUrl, getCurrentUserId } from '../../helpers/utility';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaPropertyTypes } from './sagaPropertyRedux';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import AppConfig from '../../config/AppConfig';
import { PropertyPicturesAndFilesDetail } from './ISagaProperty';
import { UPLOAD_LIMIT } from '../../config/imageConstant';

export function* requestPropertyActions(action) {
    const tag = '[REQUEST_PROPERTY_ACTIONS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetPropertyActions, jwtToken, action.propertyId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestPropertyActions response :`, response.data);
                yield put(Actions.propertyActionsSuccess(response.data.result));
            } else {
                console.warn(`${tag} requestPropertyActions invalid response :`, response);
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('project.NotLoggedIn');  // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestPropertyActions failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.propertyActionsFailure(message));
    }
}

export function* requestGetLatestPropertiesView(action) {
    const tag = '[REQUEST_GET_LATEST_PROPERTIES_VIEW]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const limit = 5;
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetLatestPropertiesView, jwtToken, action.userId, branchId, limit, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetLatestPropertiesView response :`, response.data);
                yield put(Actions.getLatestPropertiesViewSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetLatestPropertiesView failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getLatestPropertiesViewFailure(message));
    }
}

export function* requestUpdatePropertyStatus(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_STATUS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const limit = 10;
        const culture = yield select(currentLanguageRfc3066Fnc);
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.UpdatePropertyStatus, jwtToken, action.propertyId, action.status);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertyStatus response :`, response.data);
                // yield put(Actions.updatePropertyStatusSuccess(response.data.result));
                yield put(Actions.requestGetLatestPropertiesView(action.userId));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyStatus failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyStatusFailure(message));
    }
}

export function* requestGetPropertyDescription(action) {
    const tag = '[REQUEST_GET_PROPERTY_DESCRIPTION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyDescription, jwtToken, action.propertyId, action.userId, branchId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyDescription response :`, response.data);
                yield put(Actions.getPropertyDescriptionSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyDescription failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyDescriptionFailure(message));
    }
}


export function* requestUpdateStandardText(action) {
    const tag = '[REQUEST_UPDATE_STANDARD_TEXT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateStandardText, jwtToken, action.standardText, action.userId, branchId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateStandardText response :`, response.data);
                yield put(Actions.updateStandardTextSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateStandardText failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateStandardTextFailure(message));
    }
}

export function* requestUpdatePropertyDescription(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_DESCRIPTION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePropertyDescription, jwtToken, action.propertyDescription, branchId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertyDescription response :`, response.data);
                yield put(Actions.updatePropertyDescriptionSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyDescription failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyDescriptionFailure(message));
    }
}

export function* requestGetPropertyList(action) {
    const tag = '[REQUEST_GET_PROPERTY_LIST]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyList, jwtToken, action.userId, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyList response :`, response.data);
                yield put(Actions.getPropertyListSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyList failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyListFailure(message));
    }
}

export function* requestGeneratePropertyListReport(action) {
    const tag = '[REQUEST_GENERATE_PROPERTY_LIST_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGeneratePropertyListReport, jwtToken, branchId, culture, action.propertyIds, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGeneratePropertyListReport response :`, response.data);
                window.open(response.data.result, '_blank');
                yield put(Actions.generatePropertyListReportSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGeneratePropertyListReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generatePropertyListReportFailure(message));
    }
}

export function* requestUpdateBatchPropertyList(action) {
    const tag = '[REQUEST_UPDATE_BATCH_PROPERTY_LIST]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateBatchPropertyList, jwtToken, branchId, culture, action.batchProperty);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateBatchPropertyList response :`, response.data);
                yield put(Actions.updateBatchPropertyListSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateBatchPropertyList failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateBatchPropertyListFailure(message));
    }
}

export function* requestGetPropertyDetail(action) {
    const tag = '[REQUEST_GET_PROPERTY_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyDetail, jwtToken, branchId, culture, action.propertyId, action.userId, action.category);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyDetail response :`, response.data);
                yield put(Actions.getPropertyDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyDetailFailure(message));
    }
}

export function* requestGetProjectUnits(action) {
    const tag = '[REQUEST_GET_PROJECT_UNITS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetProjectUnits, jwtToken, action.projectId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetProjectUnits response :`, response.data);
                yield put(Actions.getProjectUnitsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetProjectUnits failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getProjectUnitsFailure(message));
    }
}

export function* requestUpdateProperty(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateProperty, jwtToken, branchId, culture, action.propertyDetail, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateProperty response :`, response.data);
                yield put(Actions.updatePropertySuccess(response.data.result));
                if (action.propertyDetail.propertyId === 0) {
                    // redirect to propertyDetail page
                    yield put(push(buildUrl(`/dashboard/property/${response.data.result.propertyDetail.propertyId}`)));
                }
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyFailure(message));
    }
}

export function* requestUpdatePropertySendToWeb(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_SEND_TO_WEB]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePropertySendToWeb, jwtToken, branchId, action.propertyId, action.userId, action.isOnWeb, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertySendToWeb response :`, response.data);
                yield put(Actions.updatePropertySendToWebSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertySendToWeb failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertySendToWebFailure(message));
    }
}

export function* requestUpdatePortalSenderForProperty(action) {
    const tag = '[REQUEST_UPDATE_PORTAL_SENDER_FOR_PROPERTY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePortalSenderForProperty, jwtToken, branchId, action.propertyId, action.portalId, action.userId, action.isSelected);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePortalSenderForProperty response :`, response.data);
                yield put(Actions.updatePortalSenderForPropertySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePortalSenderForProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePortalSenderForPropertyFailure(message));
    }
}

export function* requestUpdatePropertyArchive(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_ARCHIVE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePropertyArchive, jwtToken, branchId, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertyArchive response :`, response.data);
                yield put(Actions.updatePropertyArchiveSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyArchive failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyArchiveFailure(message));
    }
}

export function* requestDeleteProperty(action) {
    const tag = '[REQUEST_DELETE_PROPERTY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestDeleteProperty, jwtToken, branchId, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDeleteProperty response :`, response.data);
                yield put(push(buildUrl(`/dashboard/properties?iframe=true`)));
                yield put(Actions.deletePropertySuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDeleteProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.deletePropertyFailure(message));
    }
}

export function* requestGenerateDynamicPropertyReport(action) {
    const tag = '[REQUEST_GENERATE_DYNAMIC_PROPERTY_REPORT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateDynamicPropertyReport, jwtToken, branchId, culture, action.reportId, action.methodName, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateDynamicPropertyReport response :`, response.data);
                window.open(response.data.result, '_blank');
                yield put(Actions.generateDynamicPropertyReportSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateDynamicPropertyReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateDynamicPropertyReportFailure(message));
    }
}

export function* requestGetPropertyPicturesAndFiles(action) {
    const tag = '[REQUEST_GET_PROPERTY_PICTURES_AND_FILES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyPicturesAndFiles, jwtToken, branchId, culture, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyPicturesAndFiles response :`, response.data);
                yield put(Actions.getPropertyPicturesAndFilesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyPicturesAndFiles failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyPicturesAndFilesFailure(message));
    }
}

export function* requestUpdateWaterMarkSetting(action) {
    const tag = '[REQUEST_UPDATE_WATER_MARK_SETTING]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateWaterMarkSetting, jwtToken, branchId, action.propertyId, action.userId, action.watermarkSetting);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateWaterMarkSetting response :`, response.data);
                yield put(Actions.updateWaterMarkSettingSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateWaterMarkSetting failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateWaterMarkSettingFailure(message));
    }
}

export function* requestGetPropertyPicturesWithWaterMark(action) {
    const tag = '[REQUEST_GET_PROPERTY_PICTURES_WITH_WATER_MARK]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyPicturesWithWaterMark, jwtToken, branchId, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyPicturesWithWaterMark response :`, response.data);
                yield put(Actions.getPropertyPicturesWithWaterMarkSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyPicturesWithWaterMark failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyPicturesWithWaterMarkFailure(message));
    }
}

export function* requestUpdatePropertyPicturesAndFiles(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_PICTURES_AND_FILES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            const validateResponse = validateUploadPictures(action.pictureAndFiles);
            if(validateResponse.isValid) {
                // step 2 : validation passed..
                const response = yield call(API.requestUpdatePropertyPicturesAndFiles, jwtToken, branchId, action.propertyId, action.userId, action.pictureAndFiles);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestUpdatePropertyPicturesAndFiles response :`, response.data);
                    yield put(Actions.updatePropertyPicturesAndFilesSuccess(response.data.result));
                } else {
                    throw new Error(response.data.error);
                }
            }
            else {
                yield put(Actions.updatePropertyPicturesAndFilesFailure(validateResponse.messages));
            }
        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyPicturesAndFiles failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyPicturesAndFilesFailure(message));
    }
}

export function validateUploadPictures(pictureAndFiles: PropertyPicturesAndFilesDetail) {
    const result = { isValid: true, messages: [] };
    if(!pictureAndFiles || pictureAndFiles === undefined || pictureAndFiles.propertyPictures === undefined) { result.isValid = false; return result; }
    if(pictureAndFiles.propertyPictures.length > UPLOAD_LIMIT) {
        result.isValid = false;
        result.messages.push('error.uploadLimitExceed');
    }
    return result;
}

export function* requestRotatePropertyPictures(action) {
    const tag = '[REQUEST_ROTATE_PROPERTY_PICTURES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRotatePropertyPictures, jwtToken, branchId, action.propertyId, action.userId, action.angle, action.pictureIds);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRotatePropertyPictures response :`, response.data);
                yield put(Actions.rotatePropertyPicturesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRotatePropertyPictures failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.rotatePropertyPicturesFailure(message));
    }
}

export function* requestUpdateCategory(action) {
    const tag = '[REQUEST_UPDATE_CATEGORY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateCategory, jwtToken, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateCategory response :`, response.data);
                yield put(Actions.updateCategorySuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/property/${action.propertyId}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateCategory failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateCategoryFailure(message));
    }
}

export function* requestConvertPropertyType(action) {
    const tag = '[REQUEST_CONVERT_PROPERTY_TYPE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestConvertPropertyType, jwtToken, action.propertyId, action.userId, action.propertyTypeId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestConvertPropertyType response :`, response.data);
                yield put(Actions.convertPropertyTypeSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/property/${action.propertyId}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestConvertPropertyType failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.convertPropertyTypeFailure(message));
    }
}

export function* requestDuplicateProperty(action) {
    const tag = '[REQUEST_DUPLICATE_PROPERTY]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestDuplicateProperty, jwtToken, branchId, culture, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDuplicateProperty response :`, response.data);
                yield put(Actions.duplicatePropertySuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/property/${response.data.result}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDuplicateProperty failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.duplicatePropertyFailure(message));
    }
}

export function* requestGetOwnersInformation(action) {
    const tag = '[REQUEST_GET_OWNERS_INFORMATION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetOwnersInformation, jwtToken, branchId, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetOwnersInformation response :`, response.data);
                yield put(Actions.getOwnersInformationSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetOwnersInformation failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getOwnersInformationFailure(message));
    }
}

export function* requestUpdateOwnersInformation(action) {
    const tag = '[REQUEST_UPDATE_OWNERS_INFORMATION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateOwnersInformation, jwtToken, branchId, action.sellerOrBuyerInformation, action.propertyId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateOwnersInformation response :`, response.data);
                yield put(Actions.updateOwnersInformationSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateOwnersInformation failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateOwnersInformationFailure(message));
    }
}

export function* requestGetPropertyActivityLogs(action) {
    const tag = '[REQUEST_GET_PROPERTY_ACTIVITY_LOGS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyActivityLogs, jwtToken, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyActivityLogs response :`, response.data);
                yield put(Actions.getPropertyActivityLogsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyActivityLogs failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyActivityLogsFailure(message));
    }
}

export function* requestCreateOrUpdatePropertyActivityLog(action) {
    const tag = '[REQUEST_CREATE_OR_UPDATE_PROPERTY_ACTIVITY_LOG]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestCreateOrUpdatePropertyActivityLog, jwtToken, action.propertyActivityDetail);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestCreateOrUpdatePropertyActivityLog response :`, response.data);
                yield put(Actions.createOrUpdatePropertyActivityLogSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestCreateOrUpdatePropertyActivityLog failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.createOrUpdatePropertyActivityLogFailure(message));
    }
}

export function* requestRemovePropertyActivityLog(action) {
    const tag = '[REQUEST_REMOVE_PROPERTY_ACTIVITY_LOG]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemovePropertyActivityLog, jwtToken, action.activityLogId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemovePropertyActivityLog response :`, response.data);
                yield put(Actions.removePropertyActivityLogSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemovePropertyActivityLog failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removePropertyActivityLogFailure(message));
    }
}

export function* requestGetpropertyPortals(action) {
    const tag = '[REQUEST_GETPROPERTY_PORTALS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetpropertyPortals, jwtToken, branchId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetpropertyPortals response :`, response.data);
                yield put(Actions.getpropertyPortalsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetpropertyPortals failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getpropertyPortalsFailure(message));
    }
}

export function* requestGetFmrDetailResponse(action) {
    const tag = '[REQUEST_GET_FMR_DETAIL_RESPONSE]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetFmrDetailResponse, jwtToken, action.mainRegId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetFmrDetailResponse response :`, response.data);
                yield put(Actions.getFmrDetailResponseSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetFmrDetailResponse failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getFmrDetailResponseFailure(message));
    }
}


export function* requestGetPropertyDocument(action) {
    const tag = '[REQUEST_GET_PROPERTY_DOCUMENT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            const response = yield call(API.requestGetPropertyDocument, jwtToken, branchId, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyDocument response :`, response.data);
                yield put(Actions.getPropertyDocumentSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyDocument failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyDocumentFailure(message));
    }
}
export function* requestUpdatePropertyDocument(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_DOCUMENT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            const response = yield call(API.requestUpdatePropertyDocument, jwtToken, branchId, userId, action.propertyId, action.documents);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertyDocument response :`, response.data);
                yield put(Actions.updatePropertyDocumentSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyDocument failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyDocumentFailure(message));
    }
}
export function* requestRemoveDocument(action) {
    const tag = '[REQUEST_REMOVE_DOCUMENT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            const response = yield call(API.requestRemoveDocument, jwtToken, branchId, userId, action.propertyId, action.referenceId, action.actionId, action.documentType);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemoveDocument response :`, response.data);
                yield put(Actions.removeDocumentSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemoveDocument failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removeDocumentFailure(message));
    }
}

export function* requestDuplicateOffer(action) {
    const tag = '[REQUEST_DUPLICATE_OFFER]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            const response = yield call(API.requestDuplicateOffer, jwtToken, branchId, userId, action.propertyId, action.offerId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDuplicateOffer response :`, response.data);
                yield put(Actions.duplicateOfferSuccess(response.data.result));
                window.open(buildUrl(`/dashboard/contractofferdetail/${response.data.result.offer.actionId}/${response.data.result.offer.propertyId}?iframe=true`), '_blank');
                //  yield put(push(buildUrl(`/dashboard/contractofferdetail/${response.data.result.offer.actionId}/${response.data.result.offer.propertyId}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDuplicateOffer failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.duplicateOfferFailure(message));
    }
}
export function* requestDownloadPropertyFile(action) {
    const tag = '[REQUEST_DOWNLOAD_PROPERTY_FILE]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            const response = yield call(API.requestDownloadPropertyFile, jwtToken, action.propertyFileId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestDownloadPropertyFile response :`, response.data);
                window.open(response.data.result, '_blank');
                yield put(Actions.downloadPropertyFileSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDownloadPropertyFile failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.downloadPropertyFileFailure(message));
    }
}

export function* requestGetpropertyHistories(action) {
    const tag = '[REQUEST_GETPROPERTY_HISTORIES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetpropertyHistories, jwtToken, branchId, culture, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetpropertyHistories response :`, response.data);
                yield put(Actions.getpropertyHistoriesSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('Not logged in.'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetpropertyHistories failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getpropertyHistoriesFailure(message));
    }
}

export function* requestRestorePropertyHistory(action) {
    const tag = '[REQUEST_RESTORE_PROPERTY_HISTORY]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRestorePropertyHistory, jwtToken, branchId, action.propertyId, action.propertyShwId, action.userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRestorePropertyHistory response :`, response.data);
                yield put(Actions.restorePropertyHistorySuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/property/${action.propertyId}?iframe=true`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRestorePropertyHistory failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.restorePropertyHistoryFailure(message));
    }
}

export function* requestGetPropertyLoans(action) {
    const tag = '[REQUEST_GET_PROPERTY_LOANS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyLoans, jwtToken, action.propertyId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyLoans response :`, response.data);
                yield put(Actions.getPropertyLoansSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyLoans failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyLoansFailure(message));
    }
}

export function* requestGetPropertyLoanDetail(action) {
    const tag = '[REQUEST_GET_PROPERTY_LOAN_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetPropertyLoanDetail, jwtToken, branchId, culture, action.propertyId, action.loanId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetPropertyLoanDetail response :`, response.data);
                yield put(Actions.getPropertyLoanDetailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetPropertyLoanDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getPropertyLoanDetailFailure(message));
    }
}

export function* requestSavePropertyLoan(action) {
    const tag = '[REQUEST_SAVE_PROPERTY_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestSavePropertyLoan, jwtToken, branchId, userId, culture, action.propertyId, action.mortgage);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSavePropertyLoan response :`, response.data);
                yield put(Actions.savePropertyLoanSuccess(response.data.result));
            } else {
                if (response.problem && response.problem === 'TIMEOUT_ERROR') {
                    throw new Error('Timeout expired:');

                } else {
                    throw new Error(response.data.error);
                }
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSavePropertyLoan failed with error :`, e);
        console.log('error 3');
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.savePropertyLoanFailure(message));
    }
}

export function* requestRemovePropertyLoan(action) {
    const tag = '[REQUEST_REMOVE_PROPERTY_LOAN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRemovePropertyLoan, jwtToken, branchId, userId, action.propertyId, action.loanId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRemovePropertyLoan response :`, response.data);
                yield put(Actions.removePropertyLoanSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRemovePropertyLoan failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.removePropertyLoanFailure(message));
    }
}

export function* requestUpdatePropertyLoanIsSent(action) {
    const tag = '[REQUEST_UPDATE_PROPERTY_LOAN_IS_SENT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdatePropertyLoanIsSent, jwtToken, action.propertyId, action.loanId, action.isSent);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdatePropertyLoanIsSent response :`, response.data);
                yield put(Actions.updatePropertyLoanIsSentSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdatePropertyLoanIsSent failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updatePropertyLoanIsSentFailure(message));
    }
}

export function* requestAddPropertyViews(action) {
    const tag = '[REQUEST_ADD_PROPERTY_VIEWS]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const userId = yield getCurrentUserId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestAddPropertyViews, jwtToken, userId, branchId, culture, action.propertyId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestAddPropertyViews response :`, response.data);
                yield put(Actions.addPropertyViewsSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestAddPropertyViews failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.addPropertyViewsFailure(message));
    }
}

export function* requestDownloadPropertyPictures(action) {
    const tag = '[REQUEST_DOWNLOAD_PROPERTY_PICTURES]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const url = `${AppConfig.sagaUrl}/v1/Properties/DownloadPropertyPictures?branchId=${branchId}&propertyId=${action.propertyId}&propertyPictureIds=${action.propertyPictureIds}`;
            window.open(url, '_blank');
        } else {
            throw new Error('Not logged in'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestDownloadPropertyPictures failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.downloadPropertyPicturesFailure(message));
    }
}


export default function* rootSaga() {
    yield all([
        takeLatest(SagaPropertyTypes.REQUEST_PROPERTY_ACTIONS, requestPropertyActions),
        takeLatest(SagaPropertyTypes.REQUEST_GET_LATEST_PROPERTIES_VIEW, requestGetLatestPropertiesView),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_STATUS, requestUpdatePropertyStatus),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_DESCRIPTION, requestGetPropertyDescription),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_STANDARD_TEXT, requestUpdateStandardText),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_DESCRIPTION, requestUpdatePropertyDescription),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_LIST, requestGetPropertyList),
        takeLatest(SagaPropertyTypes.REQUEST_GENERATE_PROPERTY_LIST_REPORT, requestGeneratePropertyListReport),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_BATCH_PROPERTY_LIST, requestUpdateBatchPropertyList),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_DETAIL, requestGetPropertyDetail),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROJECT_UNITS, requestGetProjectUnits),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY, requestUpdateProperty),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_SEND_TO_WEB, requestUpdatePropertySendToWeb),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PORTAL_SENDER_FOR_PROPERTY, requestUpdatePortalSenderForProperty),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_ARCHIVE, requestUpdatePropertyArchive),
        takeLatest(SagaPropertyTypes.REQUEST_DELETE_PROPERTY, requestDeleteProperty),
        takeLatest(SagaPropertyTypes.REQUEST_GENERATE_DYNAMIC_PROPERTY_REPORT, requestGenerateDynamicPropertyReport),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_PICTURES_AND_FILES, requestGetPropertyPicturesAndFiles),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_WATER_MARK_SETTING, requestUpdateWaterMarkSetting),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_PICTURES_WITH_WATER_MARK, requestGetPropertyPicturesWithWaterMark),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_PICTURES_AND_FILES, requestUpdatePropertyPicturesAndFiles),
        takeLatest(SagaPropertyTypes.REQUEST_ROTATE_PROPERTY_PICTURES, requestRotatePropertyPictures),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_CATEGORY, requestUpdateCategory),
        takeLatest(SagaPropertyTypes.REQUEST_CONVERT_PROPERTY_TYPE, requestConvertPropertyType),
        takeLatest(SagaPropertyTypes.REQUEST_DUPLICATE_PROPERTY, requestDuplicateProperty),
        takeLatest(SagaPropertyTypes.REQUEST_GET_OWNERS_INFORMATION, requestGetOwnersInformation),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_OWNERS_INFORMATION, requestUpdateOwnersInformation),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_ACTIVITY_LOGS, requestGetPropertyActivityLogs),
        takeLatest(SagaPropertyTypes.REQUEST_CREATE_OR_UPDATE_PROPERTY_ACTIVITY_LOG, requestCreateOrUpdatePropertyActivityLog),
        takeLatest(SagaPropertyTypes.REQUEST_REMOVE_PROPERTY_ACTIVITY_LOG, requestRemovePropertyActivityLog),
        takeLatest(SagaPropertyTypes.REQUEST_GETPROPERTY_PORTALS, requestGetpropertyPortals),
        takeLatest(SagaPropertyTypes.REQUEST_GET_FMR_DETAIL_RESPONSE, requestGetFmrDetailResponse),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_DOCUMENT, requestGetPropertyDocument),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_DOCUMENT, requestUpdatePropertyDocument),
        takeLatest(SagaPropertyTypes.REQUEST_REMOVE_DOCUMENT, requestRemoveDocument),
        takeLatest(SagaPropertyTypes.REQUEST_DUPLICATE_OFFER, requestDuplicateOffer),
        takeLatest(SagaPropertyTypes.REQUEST_DOWNLOAD_PROPERTY_FILE, requestDownloadPropertyFile),
        takeLatest(SagaPropertyTypes.REQUEST_GETPROPERTY_HISTORIES, requestGetpropertyHistories),
        takeLatest(SagaPropertyTypes.REQUEST_RESTORE_PROPERTY_HISTORY, requestRestorePropertyHistory),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_LOANS, requestGetPropertyLoans),
        takeLatest(SagaPropertyTypes.REQUEST_GET_PROPERTY_LOAN_DETAIL, requestGetPropertyLoanDetail),
        takeLatest(SagaPropertyTypes.REQUEST_SAVE_PROPERTY_LOAN, requestSavePropertyLoan),
        takeLatest(SagaPropertyTypes.REQUEST_REMOVE_PROPERTY_LOAN, requestRemovePropertyLoan),
        takeLatest(SagaPropertyTypes.REQUEST_UPDATE_PROPERTY_LOAN_IS_SENT, requestUpdatePropertyLoanIsSent),
        takeLatest(SagaPropertyTypes.REQUEST_ADD_PROPERTY_VIEWS, requestAddPropertyViews),
        takeLatest(SagaPropertyTypes.REQUEST_DOWNLOAD_PROPERTY_PICTURES, requestDownloadPropertyPictures),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaProperty/sagaPropertySaga.ts